import React, { useContext, useEffect } from "react";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import BryntumContext from "../../context/bryntumContext.jsx";
import SwivuResourceEditorV2 from "./SwivuResourceEditorV2.jsx";
import CompanyCamModal from "../CompanyCamModal.jsx";
import AuthContext from "../../context/authContext.jsx";
import ImportPopup from "./ImportPopup.jsx";
import { SwivuAboutModal } from "../../../bryntum-lib/editors/about/SwivuAbout.jsx";
import SwivuTaskCopyMenuEditor from "./SwivuTaskCopyMenuEditor.jsx";
import SwivuClientsEditorV2 from "./SwivuClientEditorV2.jsx";
import SwivuShareSchedulePopup from "./ShareSchedulePopup.jsx";
import SwivuRichTextEditor from "../SwivuRichTextEditor.jsx";
import SwivuUserEditorPopup from "../../../bryntum-lib/editors/userEditor/SwivuUserEditor.jsx";
import SwivuContactFinderPopup from "./SwivuContactFinder.jsx";
import SwivuUserProfilePopup from "./SwivuUserProfileEditor.jsx";
import SwivuEntityFinder from "./SwivuEntityFinder.jsx";
import SwivuSettingPersonalEditor from "./SwivuSettingPersonalEditor.jsx";
import SwivuSettingGeneralEditor from "./SwivuSettingGeneralEditor.jsx";
import SwivuTimelineConfiguratorEditorPopup from "../../../bryntum-lib/editors/timelineConfiguratorEditor/SwivuTimelineConfiguratorEditor.jsx";
import SwivuEntityTagEditorPopup from "../../../bryntum-lib/editors/entityTagEditor/SwivuEntityTagEditorPopup.jsx";
import SwivuChecklistItemPopup from "./SwivuChecklistItemEditor.jsx";
import SwivuViewOrganizerEditor from "./SwivuViewOrganizerEditor.jsx";
import SwivuBoardAlertsPopup from "./SwivuBoardAlertsEditor.jsx";
import SwivuBudgetEditor from "./SwivuBudgetEditor.jsx";
import useEditorLiveUpdate from "../../hooks/useEditorLiveUpdate.jsx";
import SwivuViewInspectorPopup from "./SwivuViewInspectorEditor.jsx";
import { SwivuCompanyCamProjectModal } from "../../../bryntum-lib/editors/swivuCompanyCamProjectsEditor/SwivuCompanyCampProjectPopup.jsx";
import SwivuAsyncMessageModal from "../../../bryntum-lib/editors/AsyncTaskMessageEditor/SwivuAsyncMessagePopup.jsx";
import { OutcomeIncentiveEditor } from "./incentive/outcome/OutcomeIncentiveEditor.jsx";
import { SpotIncentiveEditor } from "./incentive/spotIncentive/SpotIncentiveEditor.jsx";
import { SwivuPointsLeaderboardPopup } from "./pointsLeaderboard/SwivuPointsLeaderboardPopup.jsx";
import SwivuAwardTagEditorPopup from "../../../bryntum-lib/editors/awardTagEditor/SwivuAwardTagEditorPopup.jsx";
import { TaskGeneralEditor } from "../entityViews/general/editors/TaskGeneralEditor";
import SwivuTaskFilesEditorPopup from "../../../bryntum-lib/editors/taskFilesEditor/SwivuTaskFilesEditor";

// Whatever key added into EditorsKey should have relevant component being attached here
const Editors = {
  [EDITOR_KEYS.taskEditor]: TaskGeneralEditor,
  [EDITOR_KEYS.resourceEditorV2]: SwivuResourceEditorV2,
  [EDITOR_KEYS.clientEditorV2]: SwivuClientsEditorV2,
  [EDITOR_KEYS.importEditor]: ImportPopup,
  [EDITOR_KEYS.aboutModal]: SwivuAboutModal,
  [EDITOR_KEYS.taskCopyMenuEditor]: SwivuTaskCopyMenuEditor,
  [EDITOR_KEYS.shareSchedulerPopup]: SwivuShareSchedulePopup,
  [EDITOR_KEYS.richTextEditor]: SwivuRichTextEditor,
  [EDITOR_KEYS.userEditor]: SwivuUserEditorPopup,
  [EDITOR_KEYS.contactFinder]: SwivuContactFinderPopup,
  [EDITOR_KEYS.viewOrganizerEditor]: SwivuViewOrganizerEditor,
  // Not being used
  [EDITOR_KEYS.userProfileEditor]: SwivuUserProfilePopup,
  [EDITOR_KEYS.entityFinder]: SwivuEntityFinder,
  [EDITOR_KEYS.settingPersonalEditor]: SwivuSettingPersonalEditor,
  [EDITOR_KEYS.settingGeneralEditor]: SwivuSettingGeneralEditor,
  [EDITOR_KEYS.timelineConfiguratorEditor]: SwivuTimelineConfiguratorEditorPopup,
  [EDITOR_KEYS.entityTagEditor]: SwivuEntityTagEditorPopup,
  [EDITOR_KEYS.checklistItemEditor]: SwivuChecklistItemPopup,
  [EDITOR_KEYS.boardAlertEditor]: SwivuBoardAlertsPopup,

  [EDITOR_KEYS.budgetEditor]: SwivuBudgetEditor,
  [EDITOR_KEYS.viewInspectorEditor]: SwivuViewInspectorPopup,
  [EDITOR_KEYS.companyCampProjectEditor]: SwivuCompanyCamProjectModal,
  [EDITOR_KEYS.asyncTaskMessageEditor]: SwivuAsyncMessageModal,
  [EDITOR_KEYS.outcomeIncentiveEditor]: OutcomeIncentiveEditor,
  [EDITOR_KEYS.spotIncentiveEditor]: SpotIncentiveEditor,
  [EDITOR_KEYS.pointsLeaderboardPopup]: SwivuPointsLeaderboardPopup,
  [EDITOR_KEYS.awardTagEditor]: SwivuAwardTagEditorPopup,
  [EDITOR_KEYS.taskFilesEditor]: SwivuTaskFilesEditorPopup,
}

const getEditorByType = ({ type }) => {
  const EditorComp = Editors[type];
  if (EditorComp) return EditorComp;
  throw new Error(`The editor "${type}" does not exists`);
};

const EditorViews = () => {
  const context = useContext(BryntumContext);
  const { user } = useContext(AuthContext);
  const { getEditors, closeEditor, closeAllEditors } = context.editorHandler;
  const editors = getEditors();
  useEditorLiveUpdate(editors, user, context.swivuWebSocketRef.current, context.boardSessionIdRef.current);

  useEffect(() => {
    if (!user) closeAllEditors();
  }, [closeAllEditors, user]);
  return (
    <>
      {editors && context?.user &&
        editors.map((editor) => {
          const Editor = getEditorByType(editor);
          return (
            <Editor
              key={editor.id}
              isShow
              context={context}
              record={editor.record}
              onClose={() => closeEditor(editor)}
              editorInstance={editor}
            />
          );
        })}
      {/* this model is seems to be controlled via direct dom target element */}
      <CompanyCamModal data={context}/>
    </>
  );
};

export default EditorViews;
